import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {darkGray, denim} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    marginBottom: indent * 0.25,
    flexGrow: 1,
    overflow: 'visible' as const,
  },
  singleCard: {
    marginBottom: indent * 0.6,
    paddingLeft: 0,
    paddingRight: 0,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: indent * 2,
    marginBottom: indent * 0.8,
    paddingHorizontal: indent,
  },
  headerText: {
    color: darkGray,
    fontSize: 16,
    flex: 1,
    minWidth: 0,
  },
  showHideButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  showHideButton: {
    color: denim,
    marginRight: indent / 2,
    fontWeight: '600',
  },
  icon: {
    fontSize: 18.5,
    fontWeight: '600',
    color: denim,
  },
});
